import PaymentProcessingModal from "../../modal/PaymentProcessingModal";
import TransactionStatusModal from "../../modal/TransactionStatusModal";
import { getCardBrandName } from "../../../utils/dlocalStyleMapper";

const DlocalCardFormView = ({
  t,
  cardholderName,
  documentNumber,
  documentError,
  pan,
  panError,
  loading,
  error,
  cardError,
  showCardError,
  cardBrand,
  detectedBrand,
  sdkLoading,
  cardReady,
  cardElementRef,
  onNameChange,
  onDocumentChange,
  onPanChange,
  showDocumentField,
  showPanField,
  showProcessingModal,
  setProcessingModal,
  showStatusModal,
  setShowStatusModal,
  transactionStatus,
  transactionId,
  checkoutConfDto,
  hostedPageRedirect,
}) => {
  return (
    <div className="card-container">
      {/* Cardholder Name */}
      <div className="form-section">
        <label className="input-label">
          {t("paymentForms.card.cardholderName")}
        </label>
        <div className="input-wrapper">
          <input
            type="text"
            className="card-input"
            placeholder={t("paymentForms.card.namePlaceholder")}
            value={cardholderName}
            onChange={onNameChange}
            disabled={loading}
            autoComplete="cc-name"
          />
        </div>
      </div>

      {/* PAN – required for Indian cards (same as UPI) */}
      {showPanField && (
        <div className="form-section">
          <label className="input-label">
            {t("paymentForms.upi.pan")}
          </label>
          <div className="input-wrapper">
            <input
              type="text"
              className="card-input"
              placeholder={t("paymentForms.upi.panPlaceholder")}
              value={pan}
              onChange={onPanChange}
              disabled={loading}
              maxLength={10}
              autoComplete="off"
            />
          </div>
          {panError && (
            <div className="error-message">{panError}</div>
          )}
        </div>
      )}

      {/* Card Details */}
      <div className="form-section">
        <label className="input-label">
          {t("paymentForms.card.cardDetails")}
          {cardBrand && (
            <span className="card-brand-badge">
              {getCardBrandName(detectedBrand || cardBrand)}
            </span>
          )}
        </label>

        <div className="card-mount-area" style={{ position: "relative" }}>
          {sdkLoading && (
            <div className="sdk-loading-text">
              {t("paymentForms.card.loadingSDK")}
            </div>
          )}
          <div
            ref={cardElementRef}
            className={`card-element-wrapper ${
              !cardReady ? "loading" : ""
            } ${showCardError && cardError ? "invalid" : ""}`}
          />
        </div>

        {showCardError && cardError && <div className="error-message">{cardError}</div>}
      </div>

      {/* CPF/CNPJ – required for Brazilian cards */}
      {showDocumentField && (
        <div className="form-section">
          <label className="input-label">
            {t("paymentForms.pix.document")}
          </label>
          <div className="input-wrapper">
            <input
              type="text"
              className="card-input"
              placeholder={t("paymentForms.pix.documentPlaceholder")}
              value={documentNumber}
              onChange={onDocumentChange}
              disabled={loading}
              maxLength={14}
              inputMode="numeric"
              autoComplete="off"
            />
          </div>
          {documentError && (
            <div className="error-message">{documentError}</div>
          )}
        </div>
      )}

      {/* General Error */}
      {error && !cardError && (
        <div className="error-message">{error}</div>
      )}

      {/* Loading Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="spinner-large" />
          <div className="loading-text">
            {t("paymentForms.card.processing")}
          </div>
        </div>
      )}

      <PaymentProcessingModal
        show={showProcessingModal}
        setShow={setProcessingModal}
      />

      <TransactionStatusModal
        show={showStatusModal}
        setShow={setShowStatusModal}
        status={transactionStatus}
        transactionId={transactionId}
        hostedPageRedirect={hostedPageRedirect}
        fallbackRedirectUrl={checkoutConfDto?.checkoutRedirectUrl}
      />
    </div>
  );
};

export default DlocalCardFormView;
